import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconBuildingStore,
  IconCalendar,
  IconClipboardList,
  IconEdit,
  IconFileExport,
  IconReceiptTax,
  IconRefresh,
  IconSearch,
  IconStatusChange,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  _timerDelayClick,
  keySearchVATManager,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById, isJSON } from "../../../_base/helper/FunctionHelper";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDMExpense } from "../../../model/TblDMExpense";
import {
  getMasterOrgSelect,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";
import ExportVAT from "../ExportVAT";
import ModalVAT from "./ModalVAT";
import ModalTimeSync from "./ModalTimeSync";

/** Quy gia tri loc ve mang chuoi. Du lieu ghim cu luu 1 chuoi nen can chuyen doi. */
const toStringArray = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(String).filter((v) => v !== "");
  if (typeof value === "string" && value !== "") return [value];
  return [];
};

/** Ma cong ty trong TBL_DM_MASTER_ORG */
const COMPANY_CODE_OPTIONS = [
  { value: "HACOM", label: "HACOM" },
  { value: "DVT", label: "DVT" },
];

const VATManagerV2 = () => {
  //data and fetching state
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMExpense[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [orderStatus] = useState<ComboboxItem[]>([
    { label: "Kho xuất hàng", value: "KHO_XUAT_HANG" },
    { label: "Đơn hàng hoàn thành", value: "DON_HANG_HOAN_THANH" },
    { label: "Đơn hàng tạm", value: "DON_HANG_TAM" },
    { label: "Đơn hàng chốt", value: "DON_HANG_CHOT" },
    { label: "Đơn hàng chờ duyệt giảm", value: "DON_HANG_CHO_DUYET_GIAM" },
    { label: "Đơn hàng đã duyệt giảm", value: "DON_HANG_DA_DUYET_GIAM" },
    { label: "Đơn chờ duyệt đổi trả", value: "DON_CHO_DUYET_DOI_TRA" },
    { label: "Đơn đã duyệt đổi trả", value: "DON_DA_DUYET_DOI_TRA" },
    { label: "Đơn hàng đổi trả tạm", value: "DON_HANG_DOI_TRA_TAM" },
    { label: "Đơn hàng đổi trả", value: "DON_HANG_DOI_TRA" },
    {
      label: "Thanh toán chưa hoàn thành",
      value: "THANH_TOAN_CHUA_HOAN_THANH",
    },
    { label: "Đang chờ xử lý", value: "pending" },
    { label: "Đơn hàng bán tại shop", value: "DON_HANG_BAN_TAI_SHOP" },
    { label: "Đơn hàng đóng", value: "DON_HANG_DONG" },
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Test OK", value: "TEST_OK" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "KTKT đang kiểm tra", value: "KTKT_DANG_KIEM_TRA" },
    { label: "GV thành công", value: "GV_THANH_CONG" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đã phân công GV", value: "DA_PHAN_CONG_GV" },
    { label: "GV đến nơi", value: "GV_DEN_NOI" },
    { label: "GV đang giao", value: "GV_DANG_GIAO" },
    { label: "Test lỗi", value: "TEST_LOI" },
    { label: "Đã phân công KTKT", value: "DA_PHAN_CONG_KTKT" },
    { label: "Hủy phân công GV", value: "HUY_PHAN_CONG_GV" },
    { label: "Thất bại do HACOM", value: "THAT_BAI_DO_HACOM" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "GV tiếp nhận", value: "GV_TIEP_NHAN" },
    { label: "GV nhập lại", value: "GV_NHAP_LAI" },
    { label: "GV nhập lại một phần", value: "GV_NHAP_LAI_MOT_PHAN" },
    { label: "GV thất bại do HACOM", value: "GV_THAT_BAI_DO_HACOM" },
    { label: "GV thất bại do KH", value: "GV_THAT_BAI_DO_KH" },
    { label: "GV nối chuyến", value: "GV_NOI_CHUYEN" },
    { label: "Hủy phân công KTKT", value: "HUY_PHAN_CONG_KTKT" },
    { label: "Có nhập lại", value: "CO_NHAP_LAI" },
    { label: "KH đã nhận", value: "DA_NHAN" },
  ]);
  const warehouseStatus = [
    { value: "DA_YEU_CAU", label: "Đã yêu cầu" },
    { value: "DANG_XUAT", label: "Đang xuất" },
    { value: "DA_XUAT", label: "Đã xuất" },
    { value: "DANG_NHAP", label: "Đang nhập" },
    { value: "DA_NHAP", label: "Đã nhập" },
  ];
  const deliveryStatus = [
    { label: "Thành công", value: "THANH_CONG" },
    { label: "Phân công", value: "PHAN_CONG" },
    { label: "Tạo mới", value: "TAO_MOI" },
    { label: "Thất bại do KH", value: "THAT_BAI_DO_KH" },
    { label: "Nhập lại", value: "NHAP_LAI" },
    { label: "Đến nơi", value: "DEN_NOI" },
    { label: "Đang giao", value: "DANG_GIAO" },
    { label: "Đã yêu cầu", value: "DA_YEU_CAU" },
    { label: "Hủy phân công", value: "HUY_PHAN_CONG" },
    { label: "Thất bại do Hacom", value: "THAT_BAI_DO_HACOM" },
    { label: "Tiếp nhận", value: "TIEP_NHAN" },
    { label: "Nhập lại một phần", value: "NHAP_LAI_MOT_PHAN" },
    { label: "Nối chuyến", value: "NOI_CHUYEN" },
  ];
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);
  const [dataProvinceNew, setDataProvinceNew] = useState<ComboboxItem[]>([]);
  const [dataCommuneNew, setDataCommuneNew] = useState<ComboboxItem[]>([]);
  const [listCommuneNew, setListCommuneNew] = useState<any[]>([]);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);

  const _searchJson = sessionStorage.getItem(keySearchVATManager)
    ? JSON.parse(sessionStorage.getItem(keySearchVATManager) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const [search, setSearch] = useState({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(
              new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                0,
                0,
                0,
                0,
              ),
            ).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(
            new Date(
              new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                0,
                0,
                0,
                0,
              ),
            ).getTime() +
              7 * 60 * 60 * 1000,
          )?.toISOString(),
    // Loc duoc nhieu chi nhanh cung luc. Du lieu ghim cu luu 1 chuoi nen phai quy ve mang.
    branchIds:
      _searchJson && checkedPinSearch
        ? toStringArray(_searchJson?.branchIds ?? _searchJson?.branchId)
        : [],
    // Ma cong ty cua chi nhanh (HACOM / DVT)
    companyCodes:
      _searchJson && checkedPinSearch
        ? toStringArray(_searchJson?.companyCodes)
        : [],
    printInvoiceCheck:
      _searchJson && checkedPinSearch ? _searchJson?.printInvoiceCheck : "",
    // Lọc được nhiều trạng thái chung đơn hàng cùng lúc
    listOrderStatus:
      _searchJson && checkedPinSearch
        ? toStringArray(_searchJson?.listOrderStatus)
        : [],
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "orderStatus",
        header: "Trạng thái chung đơn hàng",
        size: 200,
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(
              renderedCellValue?.toString() ?? "",
              orderStatus,
              "label",
            ) || renderedCellValue}
          </Text>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "printInvoiceCheck",
        header: "Loại",
        size: 70,
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue === 0
              ? "Không"
              : renderedCellValue === 1
                ? "Có"
                : "Nợ"}
          </Text>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "branchCode",
        header: "Chi nhánh",
        size: 80,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "orderNumber",
        header: "Mã đơn hàng",
        size: 200,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue && renderedCellValue !== null ? (
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => handleCheckView(row)}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "orderDate",
        header: "Thời gian",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "attribute3",
        header: "Trạng thái xuất kho",
        size: 200,
        Cell: ({ renderedCellValue, row }) => {
          const _status = warehouseStatus.find(
            (status) => status.value === row?.original?.attribute3?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "shippingStatus",
        header: "Trạng thái giao vận",
        size: 200,
        Cell: ({ renderedCellValue, row }) => {
          const _status = deliveryStatus.find(
            (status) =>
              status.value === row?.original?.shippingStatus?.toString(),
          );

          return (
            <Badge size="sm" color="cyan">
              {_status?.label ? _status.label : "Chưa yêu cầu"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "debtCode",
        header: "Mã ĐTCN",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "debtName",
        header: "Tên ĐTCN",
        size: 250,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "dateWriteOrder",
        header: "Ngày viết hóa đơn",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "customerCode",
        header: "Mã KH",
        Cell: ({ renderedCellValue }) => (
          <Badge color="blue" variant="dot">
            {renderedCellValue}
          </Badge>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
        size: 225,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }: any) => <>{row?.original?.customerName || ""}</>,
      },
      {
        accessorKey: "companyName",
        header: "Tên doanh nghiệp",
        size: 225,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const dataEntryCheck = isJSON(String(row.original.attribute57) || "")
            ? (() => {
                const parsed = JSON.parse(String(row.original.attribute57));
                return parsed && typeof parsed === "object"
                  ? Object.values(parsed).every((i) => {
                      if (i === null || String(i).length === 0) {
                        return true;
                      } else {
                        return false;
                      }
                    })
                  : false;
              })()
            : false;

          const dataRender =
            row.original.printInvoiceCheck === 0
              ? row.original.companyName
              : row.original.printInvoiceCheck === 2 ||
                  row.original.printInvoiceCheck === 1
                ? row.original.attribute57 &&
                  String(row.original.attribute57).length > 0 &&
                  !dataEntryCheck
                  ? isJSON(String(row.original.attribute57) || "")
                    ? JSON.parse(String(row.original.attribute57) || "")
                        ?.TaxCompany
                    : row.original.attribute57
                  : row.original.companyName
                : "";

          return (
            <Text fw={500} size="12.5px">
              {dataRender}
            </Text>
          );
        },
      },
      {
        accessorKey: "address",
        header: "Địa chỉ",
        Cell: ({ row }) => {
          const dataEntryCheck = isJSON(String(row.original.attribute57) || "")
            ? (() => {
                const parsed = JSON.parse(String(row.original.attribute57));
                return parsed && typeof parsed === "object"
                  ? Object.values(parsed).every((i) => {
                      if (i === null || String(i).length === 0) {
                        return true;
                      } else {
                        return false;
                      }
                    })
                  : false;
              })()
            : false;

          const value = isJSON(row.original.address)
            ? JSON.parse(row.original.address)
            : row.original.address;

          const attribute57 = isJSON(String(row.original.attribute57) || "")
            ? JSON.parse(String(row.original.attribute57) || "")?.TaxAddress
            : row.original.attribute57;

          const dataAddress = Array.isArray(value)
            ? [
                value[0]?.address || "",
                getValueById(
                  String(value[0]?.commune || ""),
                  dataCommuneNew,
                  "label",
                ),
                getValueById(
                  String(value[0]?.province || ""),
                  dataProvinceNew,
                  "label",
                ),
              ]
                .filter((i: string) => i && i.length > 0)
                .join(",")
                .trim()
            : typeof value === "object"
              ? [
                  value?.address,
                  getValueById(String(value?.commune), dataCommuneNew, "label"),
                  getValueById(
                    String(value?.province),
                    dataProvinceNew,
                    "label",
                  ),
                ]
                  .filter((i: string) => i && i.length > 0)
                  .join(",")
                  .trim()
              : row.original.address.trim();

          const dataRender =
            row.original.printInvoiceCheck === 0
              ? dataAddress
              : row.original.printInvoiceCheck === 2 ||
                  row.original.printInvoiceCheck === 1
                ? row.original.attribute57 &&
                  String(row.original.attribute57).length > 0 &&
                  !dataEntryCheck
                  ? attribute57
                  : dataAddress
                : "";

          return (
            <Text fw={500} size="12.5px">
              {dataRender}
            </Text>
          );
        },
        size: 550,
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "taxCode",
        header: "Mã ST",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const dataEntryCheck = isJSON(String(row.original.attribute57) || "")
            ? (() => {
                const parsed = JSON.parse(String(row.original.attribute57));
                return parsed && typeof parsed === "object"
                  ? Object.values(parsed).every((i) => {
                      if (i === null || String(i).length === 0) {
                        return true;
                      } else {
                        return false;
                      }
                    })
                  : false;
              })()
            : false;

          const dataRender =
            row.original.printInvoiceCheck === 0
              ? row.original.taxCode
              : row.original.printInvoiceCheck === 2 ||
                  row.original.printInvoiceCheck === 1
                ? row.original.attribute57 &&
                  String(row.original.attribute57).length > 0 &&
                  !dataEntryCheck
                  ? isJSON(String(row.original.attribute57) || "")
                    ? JSON.parse(String(row.original.attribute57) || "")
                        ?.TaxCode
                    : row.original.attribute57
                  : row.original.taxCode
                : "";

          return (
            <Text fw={500} size="12.5px">
              {dataRender}
            </Text>
          );
        },
      },
      {
        accessorKey: "email",
        header: "Email",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const dataEntryCheck = isJSON(String(row.original.attribute57) || "")
            ? (() => {
                const parsed = JSON.parse(String(row.original.attribute57));
                return parsed && typeof parsed === "object"
                  ? Object.values(parsed).every((i) => {
                      if (i === null || String(i).length === 0) {
                        return true;
                      } else {
                        return false;
                      }
                    })
                  : false;
              })()
            : false;

          const attribute57 = isJSON(String(row.original.attribute57) || "")
            ? JSON.parse(String(row.original.attribute57) || "")?.TaxEmail
            : row.original.attribute57;

          const dataRender =
            row.original.printInvoiceCheck === 0
              ? row.original.email && String(row.original.email).length > 0
                ? row.original.email
                : ""
              : row.original.printInvoiceCheck === 2 ||
                  row.original.printInvoiceCheck === 1
                ? row.original.attribute57 &&
                  String(row.original.attribute57).length > 0 &&
                  !dataEntryCheck
                  ? attribute57
                  : row.original.email && String(row.original.email).length > 0
                    ? row.original.email
                    : ""
                : "";

          return (
            <Text fw={500} size="12.5px">
              {dataRender}
            </Text>
          );
        },
      },
      // {
      //   accessorKey: "numberAmount",
      //   header: "Số tiền",
      //   Cell: ({ renderedCellValue }) => (
      //     <Text fw={500} size="12.5px">
      //       {Number(renderedCellValue)?.toLocaleString()} VNĐ
      //     </Text>
      //   ),
      //   enableColumnActions: false,
      //   enableColumnFilter: false,
      //   enableSorting: false,
      // },
      {
        accessorKey: "amountTotal",
        header: "Tổng tiền đơn hàng",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {Number(renderedCellValue)?.toLocaleString()} VNĐ
          </Text>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "phiShip",
        header: "Phí ship",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {Number(renderedCellValue).toLocaleString()} VNĐ
            </Text>
          ) : (
            <></>
          ),
      },
      // {
      //   accessorKey: "amountRemaining",
      //   header: "Tiền nhập lại",
      //   Cell: ({ renderedCellValue }) => (
      //     <Text fw={500} size="12.5px">
      //       {Number(renderedCellValue)?.toLocaleString()} VNĐ
      //     </Text>
      //   ),
      //   enableColumnActions: false,
      //   enableColumnFilter: false,
      //   enableSorting: false,
      // },
      {
        accessorKey: "dateCreateWriteOrder",
        header: "Thời gian viết",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "writeNumberOrder",
        header: "Số hóa đơn",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "employeeWriteOrder",
        header: "Nhân viên viết hóa đơn",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "managerEditOrder",
        header: "Người chỉnh sửa",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableResizing: false,
        enableSorting: false,
        size: 100,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Menu position="left">
              <Menu.Target>
                <Tooltip label="Thông tin xuất hóa đơn VAT">
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="#15AABF"
                  >
                    <IconReceiptTax size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              </Menu.Target>
              <Menu.Dropdown>
                <ExportVAT
                  data={
                    row.original.printInvoiceCheck === 0
                      ? JSON.stringify({
                          TaxCode: row.original.taxCode,
                          TaxEmail:
                            row.original.email &&
                            String(row.original.email).length > 0
                              ? row.original.email
                              : "",
                          TaxCompany: row.original.companyName,
                          TaxAddress: (() => {
                            const value = isJSON(row.original.address)
                              ? JSON.parse(row.original.address)
                              : row.original.address;

                            return Array.isArray(value)
                              ? [
                                  value[0]?.address || "",
                                  getValueById(
                                    String(value[0]?.commune || ""),
                                    dataCommuneNew,
                                    "label",
                                  ),
                                  getValueById(
                                    String(value[0]?.province || ""),
                                    dataProvinceNew,
                                    "label",
                                  ),
                                ]
                                  .filter((i: string) => i && i.length > 0)
                                  .join(",")
                                  .trim()
                              : typeof value === "object"
                                ? [
                                    value?.address,
                                    getValueById(
                                      String(value?.commune),
                                      dataCommuneNew,
                                      "label",
                                    ),
                                    getValueById(
                                      String(value?.province),
                                      dataProvinceNew,
                                      "label",
                                    ),
                                  ]
                                    .filter((i: string) => i && i.length > 0)
                                    .join(",")
                                    .trim()
                                : row.original.address.trim();
                          })(),
                        })
                      : row.original.printInvoiceCheck === 2 ||
                          row.original.printInvoiceCheck === 1
                        ? (() => {
                            const dataEntryCheck = isJSON(
                              String(row.original.attribute57) || "",
                            )
                              ? (() => {
                                  const parsed = JSON.parse(
                                    String(row.original.attribute57),
                                  );
                                  return parsed && typeof parsed === "object"
                                    ? Object.values(parsed).every((i) => {
                                        if (
                                          i === null ||
                                          String(i).length === 0
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      })
                                    : false;
                                })()
                              : false;

                            if (!dataEntryCheck) {
                              return row.original.attribute57;
                            } else {
                              return JSON.stringify({
                                TaxCode: row.original.taxCode,
                                TaxEmail:
                                  row.original.email &&
                                  String(row.original.email).length > 0
                                    ? row.original.email
                                    : "",
                                TaxCompany: row.original.companyName,
                                TaxAddress: (() => {
                                  const value = isJSON(row.original.address)
                                    ? JSON.parse(row.original.address)
                                    : row.original.address;

                                  return Array.isArray(value)
                                    ? [
                                        value[0]?.address || "",
                                        getValueById(
                                          String(value[0]?.commune || ""),
                                          dataCommuneNew,
                                          "label",
                                        ),
                                        getValueById(
                                          String(value[0]?.province || ""),
                                          dataProvinceNew,
                                          "label",
                                        ),
                                      ]
                                        .filter(
                                          (i: string) => i && i.length > 0,
                                        )
                                        .join(",")
                                        .trim()
                                    : typeof value === "object"
                                      ? [
                                          value?.address,
                                          getValueById(
                                            String(value?.commune),
                                            dataCommuneNew,
                                            "label",
                                          ),
                                          getValueById(
                                            String(value?.province),
                                            dataProvinceNew,
                                            "label",
                                          ),
                                        ]
                                          .filter(
                                            (i: string) => i && i.length > 0,
                                          )
                                          .join(",")
                                          .trim()
                                      : row.original.address.trim();
                                })(),
                              });
                            }
                          })()
                        : JSON.stringify({})
                  }
                  code={row.original.orderNumber}
                />
              </Menu.Dropdown>
            </Menu>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                color="orange"
                onClick={() =>
                  modalsEdits(
                    row.original.orderNumber,
                    row.original.printInvoiceCheck === 0
                      ? (() => {
                          const value = isJSON(row.original.address)
                            ? JSON.parse(row.original.address)
                            : row.original.address;

                          return Array.isArray(value)
                            ? [
                                value[0]?.address || "",
                                getValueById(
                                  String(value[0]?.commune || ""),
                                  dataCommuneNew,
                                  "label",
                                ),
                                getValueById(
                                  String(value[0]?.province || ""),
                                  dataProvinceNew,
                                  "label",
                                ),
                              ]
                                .filter((i: string) => i && i.length > 0)
                                .join(",")
                                .trim()
                            : typeof value === "object"
                              ? [
                                  value?.address,
                                  getValueById(
                                    String(value?.commune),
                                    dataCommuneNew,
                                    "label",
                                  ),
                                  getValueById(
                                    String(value?.province),
                                    dataProvinceNew,
                                    "label",
                                  ),
                                ]
                                  .filter((i: string) => i && i.length > 0)
                                  .join(",")
                                  .trim()
                              : row.original.address.trim();
                        })()
                      : row.original.printInvoiceCheck === 2 ||
                          row.original.printInvoiceCheck === 1
                        ? (() => {
                            const dataEntryCheck = isJSON(
                              String(row.original.attribute57) || "",
                            )
                              ? (() => {
                                  const parsed = JSON.parse(
                                    String(row.original.attribute57),
                                  );
                                  return parsed && typeof parsed === "object"
                                    ? Object.values(parsed).every((i) => {
                                        if (
                                          i === null ||
                                          String(i).length === 0
                                        ) {
                                          return true;
                                        } else {
                                          return false;
                                        }
                                      })
                                    : false;
                                })()
                              : false;

                            if (!dataEntryCheck) {
                              return row.original.attribute57 &&
                                String(row.original.attribute57).length > 0
                                ? isJSON(String(row.original.attribute57) || "")
                                  ? JSON.parse(
                                      String(row.original.attribute57) || "",
                                    )?.TaxAddress
                                  : ""
                                : "";
                            } else {
                              const dataAddress = (() => {
                                const value = isJSON(row.original.address)
                                  ? JSON.parse(row.original.address)
                                  : row.original.address;

                                return Array.isArray(value)
                                  ? [
                                      value[0]?.address || "",
                                      getValueById(
                                        String(value[0]?.commune || ""),
                                        dataCommuneNew,
                                        "label",
                                      ),
                                      getValueById(
                                        String(value[0]?.province || ""),
                                        dataProvinceNew,
                                        "label",
                                      ),
                                    ]
                                      .filter((i: string) => i && i.length > 0)
                                      .join(",")
                                      .trim()
                                  : typeof value === "object"
                                    ? [
                                        value?.address,
                                        getValueById(
                                          String(value?.commune),
                                          dataCommuneNew,
                                          "label",
                                        ),
                                        getValueById(
                                          String(value?.province),
                                          dataProvinceNew,
                                          "label",
                                        ),
                                      ]
                                        .filter(
                                          (i: string) => i && i.length > 0,
                                        )
                                        .join(",")
                                        .trim()
                                    : row.original.address.trim();
                              })();

                              return dataAddress;
                            }
                          })()
                        : "",
                    row.original.writeNumberOrder,
                  )
                }
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [orderStatus, dataProvinceNew, dataCommuneNew],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string | string[], key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.orderNumber}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.orderNumber.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.orderId,
            orderNumber: row.original.orderNumber,
            orderType: row.original.orderType,
            actionType: "view",
          },
        });
      }
    }
  };

  const modalsEdits = (
    orderNumber: any,
    address: string,
    writeNumberOrder: string,
  ) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Viết hóa đơn VAT</Title>
        </>
      ),
      size: "auto",
      children: (
        <ModalVAT
          orderNumber={orderNumber}
          onClose={setDeleteViewStatus}
          address={address}
          writeNumberOrder={writeNumberOrder}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalSyncVAT = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Đồng bộ hóa đơn VAT</Title>,
      size: "auto",
      children: <ModalTimeSync onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate.length > 0) {
      url += `&StartTimeCreate=${search.startDate}`;
    }

    if (search.endDate.length > 0) {
      url += `&EndTimeCreate=${search.endDate}`;
    }

    // Nhieu chi nhanh: lap lai tham so BrandID cho tung id
    search.branchIds.forEach((id: string) => {
      url += `&BrandID=${id}`;
    });

    // Nhieu ma cong ty: HACOM / DVT
    search.companyCodes.forEach((code: string) => {
      url += `&CompanyCode=${encodeURIComponent(code)}`;
    });

    if (search.printInvoiceCheck.length > 0) {
      url += `&PrintInvoiceCheck=${search.printInvoiceCheck}`;
    }

    // Nhieu trang thai don hang: lap lai tham so ListOrderStatus cho tung gia tri
    search.listOrderStatus.forEach((status: string) => {
      url += `&ListOrderStatus=${encodeURIComponent(status)}`;
    });

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblOrderHeaderVat/get-list-Vat${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        keySearchVATManager,
        JSON.stringify({ ...search, keySearch: keySearch }),
      );
    }
    startCountdown();
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/ExportExcel/export-order-header-vat?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.startDate.length > 0) {
        url += `&StartTimeCreate=${search.startDate}`;
      }

      if (search.endDate.length > 0) {
        url += `&EndTimeCreate=${search.endDate}`;
      }

      // Nhieu chi nhanh: lap lai tham so BrandID cho tung id
      search.branchIds.forEach((id: string) => {
        url += `&BrandID=${id}`;
      });

      // Nhieu ma cong ty: HACOM / DVT
      search.companyCodes.forEach((code: string) => {
        url += `&CompanyCode=${encodeURIComponent(code)}`;
      });

      if (search.printInvoiceCheck.length > 0) {
        url += `&PrintInvoiceCheck=${search.printInvoiceCheck}`;
      }

      // Nhieu trang thai don hang: lap lai tham so ListOrderStatus cho tung gia tri
      search.listOrderStatus.forEach((status: string) => {
        url += `&ListOrderStatus=${encodeURIComponent(status)}`;
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "quan_ly_viet_hoa_don_vat" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceNew(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const fetchDataCommuneNew = async () => {
    let url = `/api/v1/TblDmCommuneMoi/get-select?`;

    if (listCommuneNew.length > 0) {
      url += listCommuneNew.map((item) => `&Ids=${item}`).join("");
    }

    const res = await repositoryMdm.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          value: String(item.value),
          label: String(item.text),
        }));
      setDataCommuneNew(data);
    }
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();
    setDataBranchSelect(
      res
        ?.filter(
          (item) =>
            item.value != null && item.text != null && item.value != "-1",
        )
        ?.map((item) => ({
          value: item.value,
          // Hiển thị "mã - tên chi nhánh", ví dụ "01 - Hai Bà Trưng"
          label: item.att1 ? `${item.att1} - ${item.text}` : item.text,
        })),
    );
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    Promise.all([getDataBranchSelect(), fetchDataProvinceNew()]);
  }, []);

  useEffect(() => {
    if (listCommuneNew.length > 0) {
      fetchDataCommuneNew();
    }
  }, [listCommuneNew]);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableRowNumbers: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <Flex wrap={"wrap"} justify={"space-between"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"xs"}>
            <Button
              leftSection={<IconRefresh size={14} />}
              variant="outline"
              onClick={() => modalSyncVAT()}
            >
              Đồng bộ hóa đơn VAT
            </Button>
            <Button
              leftSection={<IconFileExport size={16} />}
              onClick={() => handleExportData()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.startDate.length > 0
                  ? new Date(search.startDate ?? "")
                  : null
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "startDate",
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 12, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.endDate.length > 0
                  ? new Date(search.endDate ?? "")
                  : null
              }
              onChange={(e) => {
                handleChangeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "endDate",
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder={search.branchIds.length > 0 ? "" : "Chi nhánh"}
              data={dataBranchSelect}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              searchable
              clearable
              hidePickedOptions
              maxDropdownHeight={300}
              value={search.branchIds}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => handleChangeSearchValue(e, "branchIds")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder={search.companyCodes.length > 0 ? "" : "Mã công ty"}
              data={COMPANY_CODE_OPTIONS}
              leftSection={<IconBuildingStore color="#15aabf" />}
              searchable
              clearable
              hidePickedOptions
              value={search.companyCodes}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => handleChangeSearchValue(e, "companyCodes")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder={
                search.listOrderStatus.length > 0
                  ? ""
                  : "Trạng thái chung đơn hàng"
              }
              data={orderStatus}
              leftSection={<IconStatusChange color="#15aabf" />}
              searchable
              clearable
              hidePickedOptions
              maxDropdownHeight={300}
              value={search.listOrderStatus}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => handleChangeSearchValue(e, "listOrderStatus")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Loại"
              data={[
                { label: "Có", value: "1" },
                { label: "Không", value: "0" },
                { label: "Nợ", value: "2" },
              ]}
              clearable
              value={String(search?.printInvoiceCheck)}
              leftSection={<IconClipboardList color="#15aabf" />}
              onChange={(e) =>
                handleChangeSearchValue(e ?? "", "printInvoiceCheck")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      columnPinning: {
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["10", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
  });

  return (
    <>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <MantineReactTable table={table} />
    </>
  );
};
export default VATManagerV2;
